// Google Analytics / Google Ads event helper.
// Gtag calls only fire if window.gtag is defined (i.e. after the user adds their GA/Ads tag).
// This lets us wire the events NOW so they light up as soon as the tag is deployed.

export function trackEvent(name, params = {}) {
  try {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', name, params);
    }
    // Also debug in dev
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.debug('[analytics]', name, params);
    }
  } catch (e) {
    // Silent
  }
}

export function trackPhoneClick(source = 'unknown', phone = '0656660571') {
  trackEvent('phone_click', { source, phone });
}

export function trackFormSubmit(form = 'unknown') {
  trackEvent('form_submit', { form });
}

export function trackLandingView(page = 'unknown') {
  trackEvent('landing_view', { page });
}

export function trackMobileCallButton() {
  trackEvent('call_button_mobile', {});
}

// ============= ESTIMATION TRANSPORT EVENTS =============

export function trackEstimationTransportView() {
  trackEvent('estimation_transport_view', {});
}

export function trackTransportTypeSelect(type) {
  // type: 'taxi' | 'vsl' | 'ambulance'
  trackEvent('transport_type_select', { transport_type: type });
}

export function trackTransportEstimationComplete(type, distanceKm, amount) {
  trackEvent('transport_estimation_complete', {
    transport_type: type,
    distance_km: distanceKm,
    amount_estimated: amount,
  });
}

export function trackTransportContactClick(type, target) {
  // target: 'inline_form' | 'callback' | 'phone' | 'landing'
  trackEvent('transport_contact_click', { transport_type: type, target });
}

export function trackTransportCallbackRequest(type) {
  trackEvent('transport_callback_request', { transport_type: type });
}

export function trackAmeliLinkClick(source = 'estimation_transport') {
  trackEvent('ameli_link_click', { source });
}

export function trackFacebookAmbulance03Click(source = 'unknown') {
  trackEvent('facebook_ambulance03_click', { source });
}
